// AV Permission Callout
export const AV_PERMISSION_CALLOUT =
  "You may see a pop-up requesting access to your camera and microphone once you enter the waiting room.";

// Provider Avatar
export const PROVIDER_IMAGE_ALT_TEXT = "Provider %name";
export const PROVIDER_IMAGE_ALT_TEXT_FALLBACK = "Provider picture";
export const PROVIDER_FALLBACK_NAME = "Your provider";
export const APPOINTMENT_TIME_FALLBACK = "Session with";

// Intro Room Layout
export const INTRO_ROOM_TITLE = "Let's get ready";
export const ENTER_WAITING_ROOM_BUTTON_LABEL = "Enter waiting room";

// Client Login
export const CLIENT_LOGIN_PROMPT = "Have an account?";
export const CLIENT_LOGIN_BUTTON_LABEL = "Log in";

// Provider Login
export const LOGIN_AS_PROVIDER_BUTTON_LABEL = "Log in as provider";

// Visitor Name Input
export const EMPTY_INPUT_ERROR_TEXT =
  "This field is required. Please enter your first and last name.";
export const TOO_LONG_INPUT_ERROR_TEXT =
  "This entry is too long. Please choose a name that is less than 40 characters.";
export const UNSAFE_CHARACTERS_INPUT_ERROR_TEXT =
  "This entry contains characters that may not be accepted. If admission fails, please try again with a different name.";
export const VISITOR_NAME_INPUT_LABEL = "What name would you like to go by?";
export const VISITOR_NAME_INPUT_OPTIONAL_SUFFIX = " (Optional)";
export const VISITOR_NAME_INPUT_PLACEHOLDER = "Chosen name";
export const CLIENT_CHOSEN_NAME_INPUT_LABEL = "Client's chosen name";

// PII Verification
export const PII_VERIFICATION_TITLE = "Let's verify your identity";
export const PII_VERIFICATION_FORM_INSTRUCTIONS =
  "Enter your details to verify your identity and continue, or use the login button to access your account";
export const FIELD_LABELS = {
  firstName: "Client first name",
  lastName: "Client last name",
  email: "Email",
  dateOfBirth: "Date of birth",
  phoneNumber: "Phone number",
} as const;
export const FIELD_PLACEHOLDERS = {
  firstName: "First name",
  lastName: "Last name",
  email: "email@example.com",
  dateOfBirth: "MM/DD/YYYY",
} as const;
export const ERROR_MESSAGES = {
  required: "This field is required",
  inputTooLong: "Please enter a shorter value",
  invalidEmail: "Please enter a valid email address",
  invalidDateOfBirth: "Please enter a valid date of birth (MM/DD/YYYY)",
  invalidPhoneNumber: "Please enter a valid phone number",
} as const;
export const PII_VERIFICATION_ERROR_CALLOUT_HEADING =
  "We could not verify your identity";

// Required Agreements
export const REQUIRED_AGREEMENTS_ERROR_CALLOUT_HEADING = "Something went wrong";
export const REQUIRED_AGREEMENTS_ERROR_CALLOUT_MESSAGE =
  "Please refresh the page to try again or contact our support team if the problem persists.";
export const REQUIRED_AGREEMENTS_PARENT_GUARDIAN_FORM_INSTRUCTIONS =
  "For parents and guardians, enter your information and accept the agreements to continue";
export const CONTACT_SUPPORT_BUTTON_LABEL = "Contact support";
export const SUBMIT_BUTTON_LABEL = "Continue";
